/**
 * Construit l'identifiant commun de l'étude : année + mois (remplis
 * automatiquement depuis la date de l'ordinateur) + le nom court saisi par
 * l'utilisateur dans les informations générales (ex: "MonEtude").
 *
 * Exemple : construireIdentifiantEtude({ anneeCreation:'2026', moisCreation:'03', reference:'MonEtude' })
 *        → '2026_03_MonEtude'
 */
export function construireIdentifiantEtude({ anneeCreation, moisCreation, reference }) {
  const nomCourt = (reference || 'Etude').trim().replace(/\s+/g, '');
  return `${anneeCreation}_${moisCreation}_${nomCourt}`;
}

/**
 * Construit la référence complète d'un document à partir de :
 *  - son préfixe (CE, Devis, PVRI, PVRF...)
 *  - l'identifiant commun de l'étude (voir construireIdentifiantEtude)
 *  - le NumDoc : un numéro qui s'incrémente à chaque génération de document,
 *    tous documents confondus, pour toute l'étude (1, 2, 3...). Il est géré
 *    par useEtude.js (commun.prochainNumDoc) et fourni par la vue qui génère
 *    le document.
 *
 * Exemple : construireReference('PVRI', '2026_03_MonEtude', 3)
 *        → '003_PVRI_2026_03_MonEtude'
 */
export function construireReference(prefixe, identifiantEtude, numDoc) {
  const numeroFormate = String(numDoc ?? '').padStart(3, '0');
  return `${numeroFormate}_${prefixe}_${identifiantEtude || 'AAAA_MM_ETUDE'}`;
}